import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Solicitacao } from '../shared/model/solicitacao';
import { SolicitacoesService } from '../shared/service/solicitacoes/solicitacoes.service';
import { LoginService } from '../shared/service/login/login.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { UtilService } from '../shared/service/util/util.service';
import { CertificadoComunicacao } from '../shared/model/certificadoComunicacao';
import { CertificadoComunicacaoService } from '../shared/service/certificado-comunicacao/certificado-comunicacao.service';
import { ProdutoGar } from '../shared/model/produtoGar';

declare var jQuery: any;

@Component({
    selector: 'app-solicitacoes-list',
    templateUrl: './solicitacoes-list.component.html',
    styleUrls: ['./solicitacoes-list.component.css']
})

export class SolicitacoesListComponent implements OnInit {
    showSpinner: boolean = false;
    solicitacoes: Solicitacao[];
    solicitacao: Solicitacao = new Solicitacao();
    certificadosComunicacao: CertificadoComunicacao[] = [];
    certificadoComunicacaoIdNome: string;
    produtosGar: ProdutoGar[] = [];
    produtoGarId: string;
    dataSource: MatTableDataSource<Solicitacao>
    organizacaoId: number;
    displayedColumns: string[] = ['nomeUsuario', 'cpfSolicitacao', 'dataSolicitacao', 'acao'];
    disabledGrupo: boolean = false;
    unidade: string;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;
    @ViewChild('myModal', { static: true }) myModal: ElementRef;
    @ViewChild('modalAprovacao', { static: true }) modalAprovacao: ElementRef;
    @ViewChild('modalConfirmaAprovacao', { static: true }) modalConfirmaAprovacao: ElementRef;
    @ViewChild('modalAviso', { static: true }) modalAviso: ElementRef;

    constructor(private solicitacoesService: SolicitacoesService,
        private loginService: LoginService,
        private certificadoComunicacaoService: CertificadoComunicacaoService,
        private utilService: UtilService) {

    }
    ngOnInit() {
        this.listarSolicitacoes();
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }

    exibirModalProdutos(sol) {
        this.showSpinner = true;
        this.solicitacao = sol;
        this.listarCertificadosComunicacao();
    }

    listarSolicitacoes() {
        this.organizacaoId = JSON.parse(localStorage.getItem("currentUser")).organizacaoId;
        this.showSpinner = true;

        this.solicitacoesService.listar(this.organizacaoId).subscribe(
            (request) => {
                this.solicitacoes = request;
                this.dataSource = new MatTableDataSource(this.solicitacoes);
                this.dataSource.paginator = this.paginator;
                this.dataSource.sort = this.sort;
                this.showSpinner = false;
            }),
            (err) => {
                this.showSpinner = false;
                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(err.message);
                }
            };
    }

    listarCertificadosComunicacao() {
        this.certificadoComunicacaoService.listar(this.organizacaoId).then(
            (request) => {
                this.certificadosComunicacao = request;
                if (this.certificadosComunicacao.length>1){
                  this.certificadoComunicacaoIdNome = "Vazio";
                }
                else if(this.certificadosComunicacao.length==1){
                  this.certificadoComunicacaoIdNome = this.certificadosComunicacao[0].id.toString() + "|" + this.certificadosComunicacao[0].nome;
                }
                console.log("Consulta para listar certificados de comunicacao realizada com sucesso");

                this.listarProdutosGar();
            }).catch((err) => {
                this.showSpinner = false;
                console.log("Erro ao consultar certificado de comunicacao");

                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(err);
                }
            });
    }

    listarProdutos() {
        this.showSpinner = true;
        this.listarProdutosGar();
    }

    listarProdutosGar() {
        if(this.certificadoComunicacaoIdNome!="Vazio") {
          let certificadoComunicacaoId = this.certificadoComunicacaoIdNome.split("|")[0];
          this.certificadoComunicacaoService.listarProdutos(Number(certificadoComunicacaoId)).then(
            (request) => {
                this.produtosGar = request;
                if (this.produtosGar.length > 0) {
                    this.produtoGarId = this.produtosGar[0].codigoGrupo + "|" + this.produtosGar[0].codigoProduto;
                    this.showSpinner = false;
                    jQuery(this.modalAprovacao.nativeElement).modal('show');
                    console.log("Consulta para listagem dos produtos gar realizada com sucesso");
                } else {
                    this.showSpinner = false;
                    jQuery(this.modalAprovacao.nativeElement).modal('hide');
                    console.log("Não há produtos para o certificado de comunicação");
                    jQuery(this.modalAviso.nativeElement).modal('show');
                }
            }).catch((err) => {
                this.showSpinner = false;
                console.log("Erro ao consultar produtos gar");
                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(err);
                }
            });
          } else {
            this.showSpinner = false;
            this.produtoGarId = "Vazio"
            jQuery(this.modalAprovacao.nativeElement).modal('show');
          }
    }

    aprovar() {
        this.showSpinner = true;
        let produtosGarSel = this.produtoGarId.split("|");
        this.solicitacao.codigoGrupo = produtosGarSel[0];
        this.solicitacao.codigoProduto = produtosGarSel[1];
        let certificadoComunicacaoId = this.certificadoComunicacaoIdNome.split("|")[0];
        this.solicitacao.idCertificadoComunicacao = Number(certificadoComunicacaoId);

        this.solicitacoesService.aprovar(this.solicitacao).subscribe(
            () => {
                this.removeItem(this.solicitacao);
                this.showSpinner = false;
                this.utilService.showSuccess("Solicitação aprovada.");
                console.log("Solicitação aprovada para a unidade: " + this.certificadoComunicacaoIdNome + "\nProduto:" + this.produtoGarId);
            },
            (err) => {
                this.showSpinner = false;

                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(err.message);
                }
            }
        );
    }

    rejeitar(sol) {
        this.showSpinner = true;
        this.solicitacoesService.rejeitar(sol, this.organizacaoId).subscribe(
            () => {
                this.removeItem(sol);
                this.showSpinner = false;
                this.utilService.showSuccess("Solicitação rejeitada.");
            },
            (err) => {
                this.showSpinner = false;

                if (err.status === 401 || err.status === 403) {
                    this.loginService.logout();
                } else {
                    this.utilService.showError(err.message);
                }
            }
        );
    }

    removeItem(sol: Solicitacao) {
        let index: number = this.solicitacoes.findIndex(
            d => d.id === sol.id);

        if (index !== -1) {
            this.solicitacoes.splice(index, 1);
            this.dataSource = new MatTableDataSource<Solicitacao>(this.solicitacoes);
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
        }
    }

    onCustom(sol) {
        this.solicitacao = sol;
        jQuery(this.myModal.nativeElement).modal('show');
    }

    confirmaAprovacao(){
      let certificadoComunicacaoNome = this.certificadoComunicacaoIdNome.split("|")[1];
      this.unidade = certificadoComunicacaoNome;
      jQuery(this.modalConfirmaAprovacao.nativeElement).modal('show');
    }
}
